var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"book",style:({ background: 'url(' + require('@/assets/graphics/bg-2nd.png') + ') no-repeat center center fixed' }),attrs:{"id":"whatwedo"}},[_c('Whatwedo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }